// frontend/src/api.js
import axios from "axios";

// Dynamic API base URL
const getApiBaseUrl = () => {
  // 1. Development: Use the value from .env if it exists
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // 2. Production: Use the same origin as the current page + /api
  // This works perfectly with your Nginx reverse proxy
  return `${window.location.origin}/api`;
};

const API_BASE = getApiBaseUrl();

const getToken = () => sessionStorage.getItem("token");

const authHeader = () => ({
  headers: {
    Authorization: `Bearer ${getToken()}`
  }
});

// ==================== API FUNCTIONS ====================
export const loginUser = async ({ username, password }) => {
  const response = await axios.post(`${API_BASE}/login`, { username, password });
  if (response.data.success && response.data.token) {
    sessionStorage.setItem("token", response.data.token);
  }
  return response.data;
};

export const searchYouTube = (query) =>
  axios.get(`${API_BASE}/search`, { 
    params: { q: query }, 
    ...authHeader() 
  }).then(res => res.data);

export const getQueue = (room = "default") =>
  axios.get(`${API_BASE}/queue`, { 
    params: { room }, 
    ...authHeader() 
  }).then(res => res.data);

export const addToQueue = ({ videoId, title, channel, addedBy, room = "default" }) =>
  axios.post(`${API_BASE}/queue`, 
    { videoId, title, channel, addedBy, room }, 
    authHeader()
  ).then(res => res.data);

export const removeFromQueue = (index, room = "default") =>
  axios.delete(`${API_BASE}/queue/${index}`, { 
    params: { room }, 
    ...authHeader() 
  }).then(res => res.data);

export const popQueue = (room = "default") =>
  axios.post(`${API_BASE}/queue/pop`, 
    { room }, 
    authHeader()
  ).then(res => res.data);

export const getRooms = () =>
  axios.get(`${API_BASE}/rooms`, authHeader()).then(res => res.data);

export const createRoom = (room) =>
  axios.post(`${API_BASE}/rooms`, { room }, authHeader()).then(res => res.data);

export const deleteRoom = (room) =>
  axios.delete(`${API_BASE}/rooms/${room}`, authHeader()).then(res => res.data);

export const getFrequentSongs = () =>
  axios.get(`${API_BASE}/frequent-songs`, authHeader()).then(res => res.data);

export const getUserPreferences = () =>
  axios.get(`${API_BASE}/user/preferences`, authHeader()).then(res => res.data);

export const saveUserPreferences = (lastRoom) =>
  axios.put(`${API_BASE}/user/preferences`, { lastRoom }, authHeader()).then(res => res.data);
